import PropTypes from 'prop-types'

import { Box, Container, Grid, Paper, Typography } from '@mui/material'

import useIsMobile from '../../../hooks/useIsMobile'

import Logo from '../../../assets/images/ctt-logo.svg'

import styles from './modalStyles'

const AuthModal = ({ title, children, onSubmit }) => {
  const isMobile = useIsMobile()

  const PaperWrapper = isMobile ? Box : Paper

  return (
    <>
      {isMobile ? (
        <Box sx={styles.logoContainer}>
          <img src={Logo} alt="" />
        </Box>
      ) : null}

      <Container component="main" sx={styles.container}>
        <PaperWrapper sx={styles.paper}>
          <Typography
            component="h1"
            variant={isMobile ? 'h2' : 'h1'}
            sx={styles.title}
          >
            {title}
          </Typography>
          <form noValidate onSubmit={onSubmit}>
            <Grid container direction="column" spacing={4}>
              {children}
            </Grid>
          </form>
        </PaperWrapper>
      </Container>
    </>
  )
}

AuthModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

export default AuthModal
